import { ROLES } from './constants';

const VALID_ROLES = new Set(Object.values(ROLES));

export const normalizeRole = (userRole) => {
  const raw = Array.isArray(userRole) ? userRole[0] : userRole;
  if (!raw || typeof raw !== 'string') return null;
  const normalized = raw.toLowerCase();
  return VALID_ROLES.has(normalized) ? normalized : null;
};
